import React from 'react';
import Content from '../../content';
import Column from '../../column/index';
import { ConditionalContentThemeProvider } from '../../content-theme';

const Text = ({
  // id,
  columnWidth,
  align,
  justify,
  card,
  cardWithPrimaryBackground,
  order,
  content,
  offset,
}) => (
  <ConditionalContentThemeProvider contentTheme={cardWithPrimaryBackground ? 'light' : null}>
    <Column
      background={cardWithPrimaryBackground ? {
        color: 'primary',
      } : null}
      columnWidth={columnWidth}
      align={align}
      justify={justify}
      card={cardWithPrimaryBackground || card}
      order={order}
      offset={offset}
    >
      <Content
        content={content}
        textAlign={justify}
      />
    </Column>
  </ConditionalContentThemeProvider>
);

export default Text;
